export default __webpack_public_path__ + "static/media/success_elite.86f633f0.gif";